import React, { useState } from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../lds/modal/Modal";
import Banner from "../lds/notifications/Banner";
import BannerHeading from "../lds/notifications/BannerHeading";
import BannerBody from "../lds/notifications/BannerBody";
import ButtonGroup from "../lds/ButtonGroup";
import Button from "../lds/Button";
import Icon from "../lds/Icon";
import Heading from "../lds/typography/Heading";
import { commifyNumber } from "../../helpers/numbers"

export default function MaxFeedsErrorModal({ reloadAction, maxFeedCount, currentFeedCount }) {
  const [loading, setLoading] = useState(false)
  const [maxFeeds, setMaxFeeds] = useState(maxFeedCount)
  const [feedCount, setFeedCount] = useState(currentFeedCount)

  const onReload = async () => {
    try {
      setLoading(true)
      await reloadAction()
    } catch(e) {
      if (e.status == 403) {
        let response = e.responseJSON
        setMaxFeeds(response.max_feeds)
        setFeedCount(response.user_feeds_count)
      } else {
        throw e;
      }
    } finally {
      setLoading(false)
    }
  }

  return <>
    <Modal
      id="max_feeds_modal"
      onClose={LegacyModalService.closeModal}
      open={true}
      distanceFromTopViewport="75px"
    >
      <ModalHeader title="Max Feed Limit Reached"/>
      { loading ? <ModalLoadingSmiley /> : <>
        <MaxFeedsModalBody maxFeeds={maxFeeds} />
        <MaxFeedsModalFooter onReload={onReload} />
      </>}
    </Modal>
  </>
}

function MaxFeedsModalBody({ maxFeeds }) {
  return <>
    <ModalBody>
      <Banner variant="warning">
        <BannerHeading>
          You've reached the maximum amount of Feeds allowed on your current Edition ({commifyNumber(maxFeeds)})
        </BannerHeading>
        <BannerBody>
          <p>To create additional Feeds, consider upgrading to a subscription plan that offers more flexibility that fits your needs.</p>
          <p>Alternatively, you can delete one of your Feeds before you can save a new one.</p>
        </BannerBody>
      </Banner>

      <br/>

      <Banner variant="info">
        <BannerHeading>
          Here's a workaround for your current Edition
        </BannerHeading>
        <BannerBody>
          <span>
            Step 1: <strong>Open</strong> your Feeds page in a new tab by
            <a href="/feeds" target="_blank"> clicking here <Icon name="link-external" className="feeds-link-external-icon" /></a>
          </span>
          <p>Step 2: <strong>Delete</strong> the Feed(s) you don't use very often</p>
          <p>Step 3: <strong>Return</strong> to this page and click the <b>Reload</b> button below</p>
        </BannerBody>
      </Banner>
    </ModalBody>
  </>
}

function MaxFeedsModalFooter({ onReload }) {
  return <>
    <ModalFooter>
        <ButtonGroup size="medium" className="align-self-end">
          <Button
            id="max-feeds-reload-button"
            size="medium"
            variant="secondary"
            onClick={onReload}
          >Reload</Button>
          <Button
            id="max-feeds-close-button"
            size="medium"
            variant="primary"
            onClick={LegacyModalService.closeModal}
          >Close</Button>
        </ButtonGroup>
    </ModalFooter>
  </>
}

function ModalLoadingSmiley() {
  return <ModalBody>
    <div className="status">
      <div className="create-happy-face-background">
        <Icon
          name="happy"
          style={{ height: 50, width: 50 }}
          className="icon-background"
        />
      </div>
      <Heading size={"h2"}>
        Loading...
      </Heading>
    </div>
  </ModalBody>
}

window.MaxFeedsErrorModal = MaxFeedsErrorModal;
